"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _toolkit = require("@reduxjs/toolkit");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var selectValues = (0, _toolkit.createSelector)(function (state) {
  return state.form.values;
}, function (value) {
  return value;
});
var WatchValues = function WatchValues(props) {
  var onValuesChange = props.onValuesChange;
  var state = (0, _reactRedux.useSelector)(selectValues);
  var firstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    // Do not trigger onValuesChange for the initial set of `values`.
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    onValuesChange && onValuesChange(state);
  }, [onValuesChange, state]);
  return null;
};
WatchValues.propTypes = {
  onValuesChange: _propTypes["default"].func
};
var _default = exports["default"] = WatchValues;